﻿class BaCarousel {
    constructor(carousel) {
        this.carousel = carousel;
        this.selectedIndex = null;
        this.itemContainer = carousel.querySelector('[data-carousel-items]')
        this.items = carousel.querySelectorAll('[data-carousel-item]')
        this.dotsContainer = carousel.querySelector('[data-carousel-dots]')
        this.dots = carousel.querySelectorAll('[data-carousel-dot]')
        this.resetScrollSnappingTimer = null;
        this.nextButton = carousel.querySelector('[data-carousel-next]')
        this.prevButton = carousel.querySelector('[data-carousel-prev]')
        this.scrollEventTimer = null;
        //console.log('carousel', this);


        if (this.items.length > 0) {
            this.dots.forEach((dot) => {
                dot.addEventListener("click", this.dotClick.bind(this, dot));
            });

            this.nextButton.addEventListener('click', this.next.bind(this));
            this.prevButton.addEventListener('click', this.prev.bind(this));

            //this.itemContainer.addEventListener('scrollend', this.scrollEnd.bind(this));
            this.itemContainer.addEventListener('scroll', this.scroll.bind(this));

            //init
            this.selectedIndex = 0;
            this.itemContainer.scrollLeft = 0;
            this.items[this.selectedIndex].classList.add('carousel-item--active');
            this.dots[this.selectedIndex].classList.add('carousel-dot--selected');

            //left offset adjustment
            window.addEventListener("resize", this.adjustLeftOffset.bind(this));
            this.adjustLeftOffset();
        }
    }

    getLeftOffset() {
        return Math.floor((document.body.offsetWidth - this.dotsContainer.offsetWidth) / 2);
    }

    adjustLeftOffset() {
        this.itemContainer.style.setProperty('--left-adjust', this.getLeftOffset() + 'px');
    }

    dotClick(dot) {
        var itemIndex = dot.getAttribute("data-item-index");
        this.showItem(itemIndex);

        //set active dot
        this.dots.forEach((d) => {
            d.classList.remove('carousel-dot--selected');
        });
        dot.classList.add('carousel-dot--selected');
    }

    next() {
        var nextIndex = this.selectedIndex + 1;
        if (nextIndex == this.items.length) nextIndex = 0;
        this.showItem(nextIndex);
    }

    prev() {
        var prevIndex = this.selectedIndex - 1;
        if (prevIndex < 0) prevIndex = this.items.length - 1;
        this.showItem(prevIndex);
    }

    showItem(itemIndex) {
        this.selectedIndex = itemIndex;
        this.itemContainer.scroll({
            left: this.items[itemIndex].offsetLeft,
            behavior: "smooth",
        });
    }

    scroll() {
        /*
        if (this.scrollEventTimer != null) {
            clearTimeout(this.scrollEventTimer);
        }

        this.scrollEventTimer = setTimeout(this.scrollEnd.bind(this), 100);
         */
        this.scrollEnd();
    }

    scrollEnd() {
        //find the nearest slide
        var smallestDifference = null;
        var closestIndex = 0;
        for (var i = 0; i < this.items.length; i++) {
            var slideScrollDifference = Math.abs(this.items[i].offsetLeft - this.itemContainer.scrollLeft);

            if (smallestDifference == null || slideScrollDifference < smallestDifference) {
                smallestDifference = slideScrollDifference;
                closestIndex = i;
            }
        }
        this.selectedIndex = closestIndex;

        //remove all active classes
        this.itemContainer.querySelectorAll('.carousel-item--active').forEach((item) => {
            item.classList.remove('carousel-item--active');
        });

        //set the active class
        this.items[this.selectedIndex].classList.add('carousel-item--active');

        //set active dot
        this.dots.forEach((d) => {
            d.classList.remove('carousel-dot--selected');
        });
        this.dots[this.selectedIndex].classList.add('carousel-dot--selected');

    }
}



document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
        new BaCarousel(carousel);
    });
});


